import { forwardRef, useState } from "react";
import {
  Modal as MuiModal,
  ModalProps as BaseModalProps,
} from "@mui/base/Modal";
import { ModalBackdrop } from "@/components";
import clsx from "clsx";
import { ModalTitleContext } from "./ModalTitleContext";

interface IModalProps extends BaseModalProps {
  zIndex?: number;
  className?: string; // For content-specific Tailwind stylesx
  disableEnforceFocus?: boolean;
}

// Forwarding ref to ensure this component can hold a ref
const Modal = forwardRef<HTMLDivElement, IModalProps>(
  (
    {
      open,
      onClose,
      children,
      className,
      zIndex = 100,
      disableEnforceFocus = true,
      ...props
    },
    ref,
  ) => {
    // Name the dialog after its ModalTitle unless the caller supplies a name.
    const [titleId, setTitleId] = useState<string | undefined>();

    return (
      <MuiModal
        ref={ref}
        open={open}
        onClose={onClose}
        disableEnforceFocus={disableEnforceFocus} // Allow TinyMCE dialogs to receive focus
        data-open={open ? "true" : "false"}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        style={{
          zIndex: `${zIndex}`,
          opacity: open ? 1 : 0,
          display: open ? "block" : "none",
        }}
        className={clsx("modal", className)}
        {...props} // Spread any additional props
        slots={{ backdrop: ModalBackdrop }} // Assign custom backdrop
      >
        <ModalTitleContext.Provider value={setTitleId}>
          {children}
        </ModalTitleContext.Provider>
      </MuiModal>
    );
  },
);

export { Modal };
